import { Observable, switchMap } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { YYYY_MM_DD_HH_MM_SS } from '@web/common';
import { DateFormatService, FileSaverService } from '@web/shared/ui';
import { OrderNumber } from '../../shared/types/order-number';
import { PublicInvoiceApiService } from '../api/services';

@Injectable({
  providedIn: 'root',
})
export class PublicInvoiceDataSourceService {
  private readonly fileSaver = inject(FileSaverService);
  private readonly dateFormat = inject(DateFormatService);
  private readonly invoiceApi = inject(PublicInvoiceApiService);

  public downloadInvoice(number: OrderNumber): Observable<void> {
    const invoiceFileName = `faktura_${number}_${this.dateFormat.format(new Date(), YYYY_MM_DD_HH_MM_SS)}`;

    return this.invoiceApi
      .downloadInvoice(number)
      .pipe(switchMap((blob) => this.fileSaver.saveAs(blob, invoiceFileName)));
  }

  public downloadTemporaryInvoice(number: OrderNumber): Observable<void> {
    const invoiceFileName = `proforma_${number}_${this.dateFormat.format(new Date(), YYYY_MM_DD_HH_MM_SS)}`;

    return this.invoiceApi
      .downloadTemporaryInvoice(number)
      .pipe(switchMap((blob) => this.fileSaver.saveAs(blob, invoiceFileName)));
  }

  public downloadRefundInvoice(number: OrderNumber): Observable<void> {
    const invoiceFileName = `faktura_korygujaca_${number}_${this.dateFormat.format(new Date(), YYYY_MM_DD_HH_MM_SS)}`;

    return this.invoiceApi
      .downloadRefundInvoice(number)
      .pipe(switchMap((blob) => this.fileSaver.saveAs(blob, invoiceFileName)));
  }
}
